import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";

const StatCard = ({ title, value, change, icon, description }) => (
	<View style={styles.statCard}>
		<View style={styles.statHeader}>
			<Ionicons name={icon} size={20} color="#666" />
			<Text style={styles.statTitle}>{title}</Text>
		</View>
		<Text style={styles.statValue}>{value}</Text>
		{description && <Text style={styles.statDescription}>{description}</Text>}
		{change && <Text style={[styles.statChange, change.startsWith("+") || change.startsWith("") ? styles.positive : styles.negative]}>{change}</Text>}
	</View>
);

const styles = StyleSheet.create({
	statCard: {
		height: 160,
		aspectRatio: 1,
		backgroundColor: "#333",
		borderRadius: 12,
		padding: 16,
	},
	statHeader: {
		flexDirection: "row",
		alignItems: "center",
		gap: 8,
		marginBottom: 12,
	},
	statTitle: {
		color: "#666",
		fontSize: 14,
	},
	statDescription: {
		color: "#666",
		fontSize: 12,
	},
	statValue: {
		color: "#fff",
		fontSize: 24,
		fontWeight: "bold",
		marginBottom: 4,
	},
	statChange: {
		fontSize: 14,
		fontWeight: "500",
	},
	positive: {
		color: "#34C759",
	},
	negative: {
		color: "#FF3B30",
	},
});

export default StatCard;
